export default {
	// 导航
    ktvfb0nf: 'Pharma-lnspiration',
	ks00rrah: '临研数字化智库平台',
	ks00ugkf: '帮助中心',
	ks00unzx: '联系方式',
	ks00vo6h: '研究中心',
	ks00we6n: '研究者',
	c7r87613: '研究者信息',
	mwaq85rg: '风险信息',
	ks00wfzw: '试验',
	ks00syzc: '试验注册',
	ks008cde: 'CTR',
	ks008ctr: 'CHI',
	ugyz099y: 'ClinicalTrials',
	ugyz09us: '美国临床试验',
	ugyzcris: 'CRiS',//韩国临床试验
	ugyccris: '韩国临床试验',//韩国临床试验
	ugyzjprn: 'JPRN',//日本临床试验
    ugycjprn: '日本临床试验',//日本临床试验
    uzanzctr: 'ANZCTR',//澳洲临床试验
    ucanzctr: '澳洲临床试验',//澳洲临床试验
	ks00wi2f: '申办方',
	ks009gys: '供应商',
	ks111cro: 'CRO',
	ks111sys: 'LAB',
	ks009cro: '合同研究组织(CRO)',
	ks009sys: '第三方实验室(LAB)',
	ks009smo: 'SMO',
	ks9other: '其他供应商',
	ks0other: '其他',
	ks0guide: '医学指南',
	ks00zdyz: '指导原则',
	ks00rprt: '报告',
	ks00wk0w: '工作台',
	// 筛选相关
	ks011n00: '筛选条件：',
	ks8lptsj: '开始日期',
	ks8lrc50: '结束日期',
	ks8lrw1w: '查询',
	ks8n4b55: '请输入',
	ixrw5h9p: '联系我们',
	vzq9z5xs: '操作',
	yqt5xooh: '退出',
	// 列表相关
	ekwmhcbb: '查看相关',
	z5pdraej: '结果',
	anu452bd: '可视化',
	q7x81wej: '地图',
	// 研究中心 - 详情
	研究中心: {
		基本信息: {
			基本信息: '基本信息',
			医院等级: '医院等级',
			备案号: '备案号',
			备案状态: '备案状态',
			医院地址: '医院地址',
			备案专业数: '备案专业数',
			研究者数: '研究者数',
			联系信息: '联系信息',
			统一社会信用代码: '统一社会信用代码',
			医院官网: '医院官网',
			医院简介: '医院简介',
			监督检查: '监督检查',
			序号: '序号',
			检查日期: '检查日期',
			检查类别: '检查类别',
			检查结果: '检查结果',
			检查情况: '检查情况',
		},
		备案专业信息: {
			备案专业信息: '备案专业信息',
			药物备案专业信息: '药物备案专业信息',
			序号: '序号',
			备案专业: '备案专业',
			姓名: '姓名',
			职称: '职称',
            器械备案专业信息: '器械备案专业信息',
            专业备案时间: '专业备案时间',
			'备案时间（首次）': '备案时间（首次）',
			备案时间: '备案时间',
			变更: '变更'
		},
		机构基本信息: {
			机构基本信息: '机构基本信息',
			序号: '序号',
			联系人: '联系人',
			联系方式: '联系方式',
			机构办公室地址: '机构办公室地址',
			机构接待时间: '机构接待时间',
		},
		机构财务信息: {
			机构财务信息: '机构财务信息',
			开票单位全称: '开票单位全称',
			单位账户: '单位账户',
			单位开户行: '单位开户行',
            打款备注要求: '打款备注要求',
		},
		机构成员: {
			机构成员: '机构成员',
			序号: '序号',
			姓名: '姓名',
			电话: '电话',
			邮箱: '邮箱',
            职责: '职责',
		},
        机构流程: {
            机构流程: '机构流程',
            机构网址: '机构网址',
            机构办公室地址: '机构办公室地址',
            机构接待时间: '机构接待时间',
            机构联系人: '机构联系人',
            机构电话: '机构电话',
            机构邮箱: '机构邮箱',
            是否需召开立项会: '是否需召开立项会',
            立项是否收费: '立项是否收费',
            立项费用: '立项费用',
            立项的要求和流程: '立项的要求和流程',
            立项资料清单: '立项资料清单',
            是否需要提供组长单位伦理批件: '是否需要提供组长单位伦理批件',
            立项资料是否需要上传CTMS系统: '立项资料是否需要上传CTMS系统',
            CTMS系统网址: 'CTMS系统网址',
            立项审核通过时间: '立项审核通过时间',
            研究产品是否由中心药房统一管理: '研究产品是否由中心药房统一管理',
            研究产品接收要求和流程: '研究产品接收要求和流程',
            机构质控要求: '机构质控要求',
            本中心是否有优选SMO公司: '本中心是否有优选SMO公司',
            监查员溯源的要求和流程: '监查员溯源的要求和流程',
            其他说明: '其他说明',
		},
		遗传办流程: {
            遗传办流程: '遗传办流程',
            遗传办主要负责人: '遗传办主要负责人',
            是否可以作为牵头递交: '是否可以作为牵头递交',
			是否有账号进行网上申报: '是否有账号进行网上申报',
			牵头递交的流程和要求: '牵头递交的流程和要求',
			承诺书医院盖章流程及要求: '承诺书医院盖章流程及要求',
			承诺书盖章所需时间: '承诺书盖章所需时间',
            递交遗传办相关资料节点: '递交遗传办相关资料节点',
            相关文件: '相关文件',
            其他要求: '其他要求',
		},
		中心关闭流程: {
			中心关闭流程: '中心关闭流程',
			机构关闭中心流程: '机构关闭中心流程',
			是否需要第三方稽查: '是否需要第三方稽查',
			是否有指定的第三方稽查单位: '是否有指定的第三方稽查单位',
			机构质控预约时限: '机构质控预约时限',
			机构质控是否收费: '机构质控是否收费',
			机构质控费用: '机构质控费用',
            相关文件: '相关文件',
            其他要求: '其他要求',
		},
        伦理流程: {
            伦理流程: '伦理流程',
            伦理网址: '伦理网址',
            伦理办公室地址: '伦理办公室地址',
            伦理接待时间: '伦理接待时间',
            伦理联系人: '伦理联系人',
            伦理电话: '伦理电话',
            伦理邮箱: '伦理邮箱',
            伦理会召开频率: '伦理会召开频率',
            伦理会召开时间: '伦理会召开时间',
            是否接受伦理前置: '是否接受伦理前置',
            是否接受中心伦理: '是否接受中心伦理',
            是否加入伦理审查互认可相关联盟: '是否加入伦理审查互认可相关联盟',
            是否接受伦理和立项同步开展: '是否接受伦理和立项同步开展',
            是否需提供组长单位伦理批件: '是否需提供组长单位伦理批件',
            伦理初审的形式: '伦理初审的形式',
            伦理初审的要求和流程: '伦理初审的要求和流程',
            伦理审核要点: '伦理审核要点',
            伦理会前需提前多久递交伦理资料: '伦理会前需提前多久递交伦理资料',
            伦理初审递交资料清单: '伦理初审递交资料清单',
            伦理初审资料需递交几份: '伦理初审资料需递交几份',
            伦理资料是否需要上传伦理系统: '伦理资料是否需要上传伦理系统',
            伦理系统网址: '伦理系统网址',
            是否提供伦理上会PPT模板: '是否提供伦理上会PPT模板',
            伦理审查费用: '伦理审查费用',
            伦理费是否必须在上会前到账: '伦理费是否必须在上会前到账',
            伦理会后多久后可拿批件: '伦理会后多久后可拿批件',
            资料递交至获取批件时间: '资料递交至获取批件时间',
			其他说明: '其他说明',
		},
		协议流程: {
			协议流程: '协议流程',
			协议签署流程: '协议签署流程',
			协议模板: '协议模板',
			协议签署所需时间: '协议签署所需时间',
			相关文件: '相关文件',
		},
		伦理财务信息: {
			伦理财务信息: '伦理财务信息',
			开票单位全称: '开票单位全称',
			单位账户: '单位账户',
			单位开户行: '单位开户行',
			打款备注要求: '打款备注要求',
        },
        主协议流程: {
            主协议流程: '主协议流程',
            协议审核主要负责人: '协议审核主要负责人',
            协议类型: '协议类型',
            协议模板要求: '协议模板要求',
            中心是否有固定协议模板: '中心是否有固定协议模板',
            中心是否接受申办方_CRO的协议模板: '中心是否接受申办方/CRO的协议模板',
            是否收取管理费: '是否收取管理费',
            是否收取税费: '是否收取税费',
            是否收取CRC管理费: '是否收取CRC管理费',
            协议审核和签署流程: '协议审核和签署流程',
            机构开始初审协议节点: '机构开始初审协议节点',
            协议审核所需时间: '协议审核所需时间',
            是否需申办方先签署协议: '是否需申办方先签署协议',
            机构开始签署协议的节点: '机构开始签署协议的节点',
            中心是否接受遗传办批件获得前签署合同: '中心是否接受遗传办批件获得前签署合同',
            协议签署所需时间: '协议签署所需时间',
            协议从初次审核到定稿签署所需时间: '协议从初次审核到定稿签署所需时间',
            中心对协议份数要求: '中心对协议份数要求',
            中心是否接受遗传办批件获得前启动: '中心是否接受遗传办批件获得前启动',
            启动前是否要求首笔款到账: '启动前是否要求首笔款到账',
            其他说明: '其他说明',
        },
        CRC协议流程: {
            CRC协议流程: 'CRC协议流程',
            中心是否要求必须签署CRC协议: '中心是否要求必须签署CRC协议',
            CRC协议审核主要负责人: 'CRC协议审核主要负责人',
            协议类型: '协议类型',
            CRC模板要求: 'CRC模板要求',
            中心是否有固定CRC协议模板: '中心是否有固定CRC协议模板',
            中心是否接受申办方_SMO的CRC协议模板: '中心是否接受申办方/SMO的CRC协议模板',
            主协议和CRC协议是否可以同时签署: '主协议和CRC协议是否可以同时签署',
            中心对CRC协议份数要求: '中心对CRC协议份数要求',
            CRC协议签署是否影响启动: 'CRC协议签署是否影响启动',
            其他说明: '其他说明',
        },
		伦理成员: {
			伦理成员: '伦理成员',
			序号: '序号',
			姓名: '姓名',
			电话: '电话',
			邮箱: '邮箱',
            职责: '职责',
            伦理委员会成员名单: '伦理委员会成员名单',
		},
		作为组长单位启动时长: {
            作为组长单位启动时长: '作为组长单位启动时长',
            平均启动时长: '平均启动时长(天)',
            平均启动时长计算方式: 'IND通过时间 至 伦理审查通过日期',
            试验登记号: '试验登记号',
            试验专业题目: '试验专业题目',
            试验分期: '试验分期',
            药物名称: '药物名称',
            申办方: '申办方',
            IND通过时间: 'IND通过时间',
            伦理审查通过日期: '伦理审查通过日期',
            首例知情时间: '首例知情时间',
            启动时长: '启动时长(天)',
        }
	},
	// 研究者 - 详情
	研究者: {
		研究者背景: {
			研究者背景: '研究者背景',
			研究者: '研究者',
			简介: '简介',
			擅长领域: '擅长领域',
			联系方式: '联系方式',
			学位: '学位',
			性别: '性别',
			年龄: '年龄',
			毕业院校: '毕业院校',
			毕业专业: '毕业专业',
			荣获荣誉: '荣获荣誉',
			医院: '医院',
			医院等级: '医院等级',
			科室: '科室',
			研究经验领域: '研究经验领域',
			职称: '职称',
			社会任职: '社会任职',
			备案专业: '备案专业',
			学术论文: '学术论文',
			组织协会: '组织协会',
		}
	},
	// 试验 - 详情
	试验: {
		基本信息: {
			基本信息: '基本信息',
			登记号: '登记号',
			试验通俗题目: '试验通俗题目',
			相关登记号: '相关登记号',
			曾用名: '曾用名',
			试验方案编号: '试验方案编号',
			临床申请受理号: '临床申请受理号',
			方案最新版本号: '方案最新版本号',
			适应症: '适应症',
			版本日期: '版本日期',
			药物类型: '药物类型',
			方案是否为联合用药: '方案是否为联合用药',
			试验专业题目: '试验专业题目',
			审批号: '审批号',
			合同研究组织: '合同研究组织',
			第三方实验室: '第三方实验室',
		},
		申办方信息: {
			申办方信息: '申办方信息',
			申办方名称: '申办方名称',
			联系人Email: '联系人Email',
			联系人姓名: '联系人姓名',
			联系人邮政地址: '联系人邮政地址',
			联系人座机: '联系人座机',
			联系人邮编: '联系人邮编',
			联系人手机: '联系人手机',
		},
		临床试验信息: {
			临床试验信息: '临床试验信息',
			试验分类: '试验分类',
			试验分期: '试验分期',
			试验目的: '试验目的',
			随机化: '随机化',
			盲法: '盲法',
			试验范围: '试验范围',
			设计类型: '设计类型',
			年龄: '年龄',
			性别: '性别',
			健康受试者: '健康受试者',
			入选标准: '入选标准',
			排除标准: '排除标准',
			序号: '序号',
			内容: '内容',
		},
		试验分组: {
			试验分组: '试验分组',
			试验药: '试验药',
			对照药: '对照药',
			序号: '序号',
			名称: '名称',
			用法: '用法',
		},
		终点指标: {
			终点指标: '终点指标',
			主要终点指标: '主要终点指标',
			次要终点指标: '次要终点指标',
			序号: '序号',
			指标: '指标',
			评价时间: '评价时间',
			终点指标选择: '终点指标选择',
		},
		研究者信息: {
			研究者信息: '研究者信息',
			单位名称: '单位名称',
			姓名: '姓名',
			学位: '学位',
			职称: '职称',
			电话: '电话',
			Email: 'Email',
			邮政地址: '邮政地址',
			邮编: '邮编',
			序号: '序号',
		},
		各参加机构信息: {
			各参加机构信息: '各参加机构信息',
			序号: '序号',
			机构名称: '机构名称',
			主要研究者: '主要研究者',
			国家: '国家',
			地区: '地区',
			城市: '城市',
		},
		伦理委员会信息: {
			伦理委员会信息: '伦理委员会信息',
			序号: '序号',
			名称: '名称',
			审查结论: '审查结论',
			审查日期: '审查日期',
		},
		试验状态信息: {
			试验状态信息: '试验状态信息',
			试验状态: '试验状态',
			第一列受试者签署知情同意书日期: '第一列受试者签署知情同意书日期',
			国内: '国内',
			国际: '国际',
			目标入组人数: '目标入组人数',
			第一例受试者入组日期: '第一例受试者入组日期',
			已入组人数: '已入组人数',
			试验终止日期: '试验终止日期',
			实际入组人数: '实际入组人数',
			试验完成日期: '试验完成日期',
			试验暂停日期: '试验暂停日期',
        },
        美国临床: {
            登记信息: 'ClinicalTrials登记信息',
            登记号: '登记号',
            实验专业题目: '实验专业题目',
            申办者: '申办者',
            试验状态: '试验状态',
            实验分期: '实验分期',
            适应症: '适应症',
        }
	},
	// chictr - 详情
	chictr: {
		基本信息: {
			基本信息: '基本信息',
			注册号: '注册号',
			最近更新日期: '最近更新日期',
			注册时间: '注册时间',
			注册号状态: '注册号状态',
			注册题目: '注册题目',
			注册题目简写: '注册题目简写',
			研究课题的正式科学名称: '研究课题的正式科学名称',
			研究课题代号: '研究课题代号(代码)',
			在二级注册机构或其它机构的注册号: '在二级注册机构或其它机构的注册号',
		},
		人员信息: {
			人员信息: '人员信息',
			申请注册联系人: '申请注册联系人',
			研究负责人: '研究负责人',
			申请注册联系人电话: '申请注册联系人电话',
			研究负责人电话: '研究负责人电话',
			申请注册联系人传真: '申请注册联系人传真',
			研究负责人传真: '研究负责人传真',
			申请注册联系人电子邮件: '申请注册联系人电子邮件',
			研究负责人电子邮件: '研究负责人电子邮件',
			申请单位网址: '申请单位网址(自愿提供)',
			研究负责人网址: '研究负责人网址(自愿提供)',
			申请注册联系人通讯地址: '申请注册联系人通讯地址',
			研究负责人通讯地址: '研究负责人通讯地址',
			申请注册联系人邮政编码: '申请注册联系人邮政编码',
			研究负责人邮政编码: '研究负责人邮政编码',
			申请人所在单位: '申请人所在单位',
		},
		伦理信息: {
			伦理信息: "伦理信息",
			是否获伦理委员会批准: "是否获伦理委员会批准",
			伦理委员会批件文号: "伦理委员会批件文号",
			伦理委员会批件附件: "伦理委员会批件附件",
			批准本研究的伦理委员会名称: "批准本研究的伦理委员会名称",
			伦理委员会批准日期: "伦理委员会批准日期",
			伦理委员会联系人: "伦理委员会联系人",
			伦理委员会联系地址: "伦理委员会联系地址",
			伦理委员会联系人电话: "伦理委员会联系人电话",
			伦理委员会联系人邮箱: "伦理委员会联系人邮箱",
		},
		研究信息: {
			研究信息: '研究信息',
			研究实施负责组长单位: '研究实施负责（组长）单位',
			研究实施负责组长单位地址: '研究实施负责（组长）单位地址',
			试验主办单位: '试验主办单位(项目批准或申办者)',
			经费或物资来源: '经费或物资来源',
			研究疾病: '研究疾病',
			研究疾病代码: '研究疾病代码',
			研究类型: '研究类型',
			研究所处阶段: '研究所处阶段',
			研究目的: '研究目的',
			药物成份或治疗方案详述: '药物成份或治疗方案详述',
			研究设计: '研究设计',
			纳入标准: '纳入标准',
			排除标准: '排除标准',
			研究实施时间: '研究实施时间',
			征募观察对象时间: '征募观察对象时间',
		},
		干预措施: {
			干预措施: "干预措施",
			序号: "序号",
			干预措施1: "干预措施",
			组别: "组别",
			样本量: "样本量",
			干预措施代码: "干预措施代码",
		},
		研究实施地点: {
			研究实施地点: "研究实施地点",
			序号: "序号",
			国家: "国家",
			省: "省(直辖市)",
			市: "市(区县)",
			单位: "单位(医院)",
			单位级别: "单位级别",
		},
		测量指标: {
			测量指标: "测量指标",
			序号: "序号",
			指标中文名: "指标中文名",
			指标类型: "指标类型",
			测量时间点: "测量时间点",
			测量方法: "测量方法",
		},
		采集人体标本: {
			采集人体标本: "采集人体标本",
			序号: "序号",
			标本中文名: "标本中文名",
			组织: "组织",
			人体标本去向: "人体标本去向",
			说明: "说明",
		},
		征募研究对象: {
			征募研究对象: "征募研究对象",
			征募研究对象情况: "征募研究对象情况",
			年龄范围: "年龄范围",
			最小: "最小",
			最大: "最大",
			性别: "性别",
			随机方法: "随机方法（请说明由何人用什么方法产生随机序列）",
		},
		试验结果: {
			试验结果: "试验结果",
			盲法: "盲法",
			试验完成后的统计结果: "试验完成后的统计结果（上传文件）",
		},
		其他: {
			其他: "其他",
			是否共享原始数据: "是否共享原始数据",
			数据采集和管理: "数据采集和管理（说明：数据采集和管理由两部分组成，一为病例记录表(Case Record Form, CRF)，二为电子采集和管理系统(Electronic Data Capture, EDC)，如ResMan即为一种基于互联网的EDC",
			共享原始数据的方式: "共享原始数据的方式（说明：请填入公开原始数据日期和方式，如采用网络平台，需填该网络平台名称和网址）",
			数据与安全监察委员会: "数据与安全监察委员会",
		},
	},
	// 美国临床 - 详情
	ClinicalTrials: {
		基本信息: {
			基本信息: "基本信息",
			申办者: "申办者",
			合作者: "合作者",
			专业题目: "专业题目",
			登记号信息: "登记号信息",
			简述: "简述",
			详细描述: "详细描述",
			研究类型: "研究类型",
			试验分期: "试验分期",
			研究设计: "研究设计",
			适应症: "适应症",
		},
		干预措施: {
			干预措施: "干预措施",
			干预类型: "干预类型",
			干预名称: "干预名称",
			描述: "描述",
			分组名称: "分组名称",
			其他名称: "其他名称",
		},
		试验分组: {
			试验分组: "试验分组",
			分组名称: "分组名称",
			分组类型: "分组类型",
			描述: "描述",
		},
		招募信息: {
			招募信息: "招募信息",
			招募状态: "招募状态",
			目标样本数: "目标样本数",
			实际样本数: "实际样本数",
			资格标准: "资格标准",
			性别: "性别",
			最小年龄: "最小年龄",
			最大年龄: "最大年龄",
			健康志愿者: "健康志愿者",
			联系人: "联系人",
			研究者: "研究者",
			所在地: "所在地",
		},
		结果指标: {
			结果指标: "结果指标",
			主要结果指标: "主要结果指标",
			次要结果指标: "次要结果指标",
        },
        试验相关文件: {
            试验相关文件: "试验相关文件",
        },
        研究结果: {
            研究结果: "研究结果",
            研究结果内容: "研究结果内容",
            相关文献: "相关文献",
        },
		更多信息: {
			更多信息: "更多信息",
			适应症列表: "适应症列表",
			干预列表: "干预列表",
			关键词: "关键词",
        },
        中国临床: {
            中国临床登记情况: '中国临床登记情况',
            登记号: '登记号',
            药物名称: '药物名称',
            申办方: '申办方',
            试验分期: '试验分期',
            试验通俗题目: '试验通俗题目',
            适应症: '适应症',
            试验状态: '试验状态',
        },
	},
	// 韩国临床 - 详情
	cris: {
		登记日期信息: {
			登记日期信息: "登记日期信息",
			首次递交日期: "首次递交日期",
			完成登记日期: "完成登记日期",
			最后更新日期: "最后更新日期",
		},
		研究基本信息: {
			研究基本信息: "研究基本信息",
			CRIS登记号: "CRIS登记号",
			唯一方案编号: "唯一方案编号",
			公开简要试验题目: "公开/简要试验题目",
			试验专业题目: "试验专业题目",
			是否属于韩国食品药品安全部监管的研究: "是否属于韩国食品药品安全部（MFDS)监管的研究",
			是否使用IND_IDE方案模板: "是否使用IND/IDE方案模板",
			是否在其他注册处注册: "是否在其他注册处注册",
			医疗福利机构批准状态: "医疗福利机构批准状态",
		},
		机构审查委员会_伦理委员会信息: {
			机构审查委员会_伦理委员会信息: "机构审查委员会/伦理委员会信息",
			批准状态: "批准状态",
			批准编号: "批准编号",
			批准日期: "批准日期",
			机构审查委员会名称: "机构审查委员会名称",
			机构审查委员会地址: "机构审查委员会地址",
			机构审查委员会电话: "机构审查委员会电话",
			是否有数据监察委员会: "是否有数据监察委员会",
		},
		联系方式: {
			联系方式: "联系方式",
			主要研究者_专业咨询联系人: "主要研究者/专业咨询联系人",
			公众咨询联系人: "公众咨询联系人",
			信息更新联系人: "信息更新联系人",
			姓名: "姓名",
			职称: "职称",
			电话: "电话",
			所属机构: "所属机构",
			地址: "地址",
		},
		试验状态: {
			试验状态: "试验状态",
			研究中心情况: "研究中心情况",
			试验整体招募状态: "试验整体招募状态",
			首例受试者入组时间: "首例受试者入组时间",
			目标入组人数: "目标入组人数",
			主要完成时间: "主要完成时间",
			研究完成时间: "研究完成时间",
			参加机构的招募情况: "参加机构的招募情况",
			机构名称: "机构名称",
			招募状态: "招募状态",
		},
		研究资金来源: {
			研究资金来源: "研究资金来源",
			资金来源: "资金来源",
			机构名称: "机构名称",
			机构类型: "机构类型",
			项目编号: "项目编号",
		},
		申办方: {
			申办方: "申办方",
			申办方名称: "申办方名称",
			机构类型: "机构类型",
		},
		研究摘要: {
			研究摘要: "研究摘要",
			摘要: "摘要",
		},
		研究设计: {
			研究设计: "研究设计",
			研究类型: "研究类型",
			研究目的: "研究目的",
			试验分期: "试验分期",
			干预模式: "干预模式",
			盲法: "盲法",
			设盲对象: "设盲对象",
			试验分配模式: "试验分配模式",
			干预类型: "干预类型",
			干预方法描述: "干预方法描述",
			试验组别数量: "试验组别数量",
			组: "组",
			组别标签: "组别标签",
			目标入组人数: "目标入组人数",
			组别类型: "组别类型",
			组别描述: "组别描述",
		},
		受试者资格: {
			受试者资格: "受试者资格",
			疾病情况: "疾病情况",
			罕见病: "罕见病",
			健康受试者: "健康受试者",
			入选标准: "入选标准",
			性别: "性别",
			年龄: "年龄",
			具体描述: "具体描述",
			排除标准: "排除标准",
		},
		研究指标的测定: {
            研究指标的测定: "结果指标测定",
            主要研究指标: "主要结果指标",
            主要研究指标类型: "主要结果指标类型",
            研究指标: "结果指标",
			测定时间点: "测定时间点",
            次要研究指标: "次要结果指标",
		},
		研究结果和发表情况: {
			研究结果和发表情况: "研究结果和发表情况",
			研究结果登记: "研究结果登记",
			最终入组人数: "最终入组人数",
			发表刊物数量: "发表刊物数量",
			研究结果上传地址: "研究结果上传地址",
			研究结果发布日期: "研究结果发布日期",
			方案或文件上传地址: "方案或文件上传地址",
			简要概述: "简要概述",
		},
		研究数据共享: {
			研究数据共享: "研究数据共享",
			共享声明: "共享声明",
			数据共享时间: "数据共享时间",
			数据共享方式: "数据共享方式",
		},
	},
	// 日本临床 - 详情
	日本: {
		基本信息: {
			基本信息: "基本信息",
			试验编号: "试验编号",
			试验专业题目: "试验专业题目",
			试验简要题目: "试验简要题目",
			招募状态: "招募状态",
			注册日期: "注册日期",
			最后信息更新日期: "最后信息更新日期",
			试验开始日期: "试验开始日期（预计日期）",
			试验结束日期: "试验结束日期（预计日期）",
			首例受试者入组日期: "首例受试者入组日期",
		},
		试验概要: {
			试验概要: "试验概要",
			试验地区: "试验地区",
			实施县: "实施县",
			目标入组人数: "目标入组人数",
			目标疾病: "目标疾病",
			研究类型: "研究类型",
			研究设计: "研究设计",
			随机化: "随机化",
            主要终点: "主要结果指标",
            次要终点: "次要结果指标",
			介入方法1: "介入方法1",
			介入方法2: "介入方法2",
		},
		入组资格: {
			入组资格: "入组资格",
			最小年龄: "最小年龄",
			最大年龄: "最大年龄",
			性别: "性别",
			入选标准: "入选标准",
			排除标准: "排除标准",
		},
		主要研究者: {
			主要研究者: "主要研究者",
			主要研究者姓名: "主要研究者姓名",
			机构名称: "机构名称",
			部门名称: "部门名称",
			地址: "地址",
			电话: "电话",
			负责实施的组织: "负责实施的组织",
			研究资助机构: "研究资助机构（研究资金来源）",
			联合实施组织: "联合实施组织（研究资金来源）",
			接待ID: "接待 ID",
		},
		试验咨询: {
			试验咨询: "试验咨询",
			地址: "地址",
			电话: "电话",
			网址: "网址",
			邮箱: "E-mail",
			联系人: "联系人",
		}
    },
    // 澳洲临床 - 详情
    澳洲临床: {
        基本信息: {
            基本信息: "基本信息",
            注册号: "注册号",
            伦理申请状态: "伦理申请状态",
            提交日期: "提交日期",
            注册日期: "注册日期",
            最后更新日期: "最后更新日期",
            提供数据共享声明的最初日期: "提供数据共享声明的最初日期",
            注册类型: "注册类型",
        },
        试验题目: {
            试验题目: "试验题目",
            试验公开题目: "试验公开题目",
            试验专业题目: "试验专业题目",
            次要ID: "次要ID",
            通用试验编号: "通用试验编号",
            试验缩写: "试验缩写",
            相关研究记录: "相关研究记录",
        },
        疾病情况: {
            疾病情况: "疾病情况",
            疾病情况描述: "疾病情况描述",
            疾病分类: "疾病分类",
            疾病代码: "疾病代码",
        },
        干预或暴露方法: {
            干预或暴露方法: "干预或暴露方法",
            研究类型: "研究类型（为Interventional干预性研究时）",
            干预暴露方法的描述 : "干预/暴露方法的描述",
            干预代码: "干预代码",
            对照处理: "对照处理",
            对照组: "对照组",
            研究类型1: "研究类型（为Iobservational观察性性研究时）",
            患者登记: "患者登记",
            目标随访时间: "目标随访时间",
            目标随访类型: "目标随访类型",
        },
        试验结果: {
            试验结果: "结果指标",
            主要终点: "主要结果指标",
            时间点: "时间点",
            次要终点: "次要结果指标",
        },
        受试者入组资格: {
            受试者入组资格: "受试者入组资格",
            主要入选标准: "主要入选标准",
            最小年龄: "最小年龄",
            最大年龄: "最大年龄",
            是否需要健康受试者: "是否需要健康受试者",
            主要排除标准: "主要排除标准",
        },
        研究设计: {
            研究设计: "研究设计",
            研究目的: "研究目的",
            分配方法: "分配方法",
            受试者登记和治疗分配程序: "受试者登记和治疗分配程序（保密分配程序）",
            生成受试者随机序列的方法: "生成受试者随机序列的方法（随机序列生产）",
            盲法: "盲法",
            盲态方: "盲态方",
            干预设计: "干预设计",
            其他设计特点: "其他设计特点",
            试验分期: "试验分期",
            终点指标类型: "终点指标类型",
            统计分析方法: "统计分析方法",
            目的: "目的",
            持续时间: "持续时间",
            样本的选择: "样本的选择",
            时间设定: "时间设定",
        },
        招募: {
            招募: "招募",
            招募状态: "招募状态",
            首例受试者入组日期: "首例受试者入组日期",
            最后一例受试者入组日期: "最后一例受试者入组日期",
            最后数据收集日期: "最后数据收集日期",
            预计: "预计",
            实际: "实际",
            样本大小: "样本大小",
            目标入组人数: "目标入组人数",
            截止目前的入组人数: "截止目前的入组人数",
            最终入组人数: "最终入组人数",
            澳大利亚招募情况: "澳大利亚招募情况",
            招募所在州: "招募所在州",
            招募所在医院: "招募所在医院",
            澳大利亚之外的招募情况: "澳大利亚之外的招募情况",
            国家: "国家",
            州省份: "州/省份",
        },
        资金和申办方: {
            资金和申办方: "资金和申办方",
            资金来源类型: "资金来源类型",
            主要申办方类型: "主要申办方类型",
            次要申办方类型: "次要申办方类型",
            其他合作方类型: "其他合作方类型",
            名称: "名称",
            地址: "地址",
            国家: "国家",
        },
        伦理批准: {
            伦理批准: "伦理批准",
            伦理申请情况: "伦理申请情况",
            伦理委员会名称: "伦理委员会名称",
            伦理委员会地址: "伦理委员会地址",
            伦理委员会所在国家: "伦理委员会所在国家",
            提交伦理审查的日期: "提交伦理审查的日期",
            批准日期: "批准日期",
            伦理批准号: "伦理批准号",
        },
        试验摘要: {
            试验摘要: "试验摘要",
            简要概况: "简要概况",
            试验网站: "试验网站",
            试验相关出版物: "试验相关出版物",
            公布的注意事项: "公布的注意事项",
        },
        联系人: {
            联系人: "联系人",
            主要研究者: "主要研究者",
            公众咨询联系人: "公众咨询联系人",
            专业咨询联系人: "专业咨询联系人",
            姓名: "姓名",
            地址: "地址",
            国家: "国家",
            电话: "电话",
            传真: "传真",
            邮箱: "邮箱",
        },
        数据共享声明: {
            数据共享声明: "数据共享声明",
            受试者的试验数据是否可用: "受试者的试验数据是否可用",
            具体共享哪些数据: "具体共享哪些数据",
            数据可用日期: "数据可用日期（开始到结束日期）",
            谁可以试用这些数据: "谁可以试用这些数据",
            这些数据可以用于什么类型的分析: "这些数据可以用于什么类型的分析",
            如何或在何处可以获得这些数据: "如何或在何处可以获得这些数据",
            有哪些证明或可用文件: "有哪些证明或可用文件",
        },
        结果摘要: {
            结果摘要: "结果摘要",
            研究结果是否已发表在同行的期刊上: "研究结果是否已发表在同行的期刊上",
            其他出版情况: "其他出版情况",
            研究结果是否以另一种形式公开: "研究结果是否以另一种形式公开",
            研究结果基本报告: "研究结果-基本报告",
            研究结果简明英文摘要: "研究结果-简明英文摘要",
        },
    },
	// 申办方 - 详情
	申办方: {
		公司摘要: {
			公司摘要: "公司摘要",
		},
		集团子公司试验: {
			集团子公司试验: "集团子公司试验",
			集团子公司名称: "集团子公司名称",
			试验总数: "试验总数",
		},
	},
	// CRO - 详情
	cro: {
		公司摘要: {
			公司摘要: "公司摘要",
		},
		集团子公司试验: {
			集团子公司试验: "集团子公司试验",
			集团子公司名称: "集团子公司名称",
			试验总数: "试验总数",
		},
	},
	// Lab - 详情
	lab: {
		公司摘要: {
			公司摘要: "公司摘要",
		},
		集团子公司试验: {
			集团子公司试验: "集团子公司试验",
			集团子公司名称: "集团子公司名称",
			试验总数: "试验总数",
		},
	},
	// Smo - 详情
	smo: {
		基本信息: {
			基本信息: "基本信息",
			机构名称: "机构名称",
			企业法人: "企业法人",
			成立日期: "成立日期",
			经营状态: "经营状态",
			营业期限: "营业期限",
			企业地址: "企业地址",
		}
	},
	// 其他供应商 - 详情
	supplier: {
		基本信息: {
			基本信息: "基本信息",
			服务信息: "服务信息",
			企业名称: "企业名称",
			公司简介: "公司简介",
			服务范围: "服务范围",
			省份: "省份",
			城市: "城市",
			重点服务领域: "重点服务领域",
			重点服务区域: "重点服务区域",
			联系人: "联系人",
			职位: "职位",
			电话: "电话",
			邮箱: "邮箱",
		}
	},
	// 医学指南 - 详情
	medicalguide: {
		医学指南: {
			医学指南: "医学指南",
			标题: "标题",
			作者: "作者",
			关键词: "关键词",
			机构: "机构",
			发布日期: "发布日期",
			摘要: "摘要",
			PDF附件: "PDF附件",
		}
	},
	// 指导原则 - 详情
	guideprinciple: {
		指导原则: {
			指导原则: "指导原则",
			专业分类: "专业分类",
			关键词: "关键词",
			适用范围: "适用范围",
			版本状态: "版本状态",
			摘要: "摘要",
			发布时间: "发布时间",
			PDF附件: "PDF附件",
			名称: "名称",
		}
	},
	// ==== 相关格局 ==== //
	相关格局: {
		// 研究中心-合作格局
		研究中心合作格局: {
			研究中心合作格局: '研究中心合作格局',
			序号: '序号',
			中心名称: '中心名称',
			合作试验数: '合作试验数',
		},
		// 申办方-合作格局
		申办方合作格局: {
			申办方合作格局: '申办方合作格局',
			序号: '序号',
			申办方名称: '申办方名称',
			合作试验数: '合作试验数',
		},
		// 研究者-合作格局
		研究者合作格局: {
			研究者合作格局: '研究者合作格局',
			序号: '序号',
			姓名: '姓名',
			合作试验数: '合作试验数',
			是否为同一研究中心: '是否为同一研究中心',
		},
		// 适应症-合作格局
		相关适应症格局: {
			相关适应症格局: '相关适应症格局',
			总数: '总数',
		},
		// 相关试验
		相关试验: {
			相关试验: '相关试验',
			序号: '序号',
			登记号: '登记号',
			试验分期: '试验分期',
			试验状态: '试验状态',
			药物名称: '药物名称',
			试验通俗题目: '试验通俗题目',
		},
		// 相关试验 - 试验分期
		相关实验_试验分期: {
			相关实验_试验分期: '相关试验-试验分期',
			状态: '状态',
			试验分期: '试验分期',
			试验数量: '试验数量',
			占比: '占比',
			个: '个',
			试验分期_药物: '试验分期-药物',
			药物名称: '药物名称',
		},
		// 相关试验 - 进行中/已完成
		相关试验_不同状态: {
			登记号: '登记号',
			试验分期: '试验分期',
			适应症: '适应症',
			申办方: '申办方',
			试验药物: '试验药物',
			试验方案: '试验方案/ID',
			状态: '状态',
			是否组长单位: '是否组长单位',
			相关试验_进行中: '相关试验-进行中的试验',
			相关试验_已完成: '相关试验-已完成的试验',
		},
		// 相关试验 - 进度
		相关试验_进度: {
			试验进度: '试验进度',
			试验进度1: '试验进度',
			试验数量: '试验数量',
			占比: '占比',
			个: '个',
			试验进度_药物: '试验进度-药物',
			药物名称: '药物名称',
		},
		// 试验数量 - 可视化
		试验数量_可视化: {
			试验数量_可视化: '试验数量-可视化',
			相关试验数量: '相关试验数量',
		},
		// 相关试验 - 可视化
		相关试验_可视化: {
			相关试验_可视化: '相关试验-可视化',
		},
		// 相关试验 - CHI
		相关试验_CHI: {
			相关试验_CHI: '相关试验-CHI',
			注册号: '注册号',
			组长单位: '组长单位',
			注册时间: '注册时间',
			注册号状态: '注册号状态',
			注册题目: '注册题目',
			申请注册联系人: '申请注册联系人',
			研究负责人: '研究负责人',
			申请人所在单位: '申请人所在单位',
			伦理委员会批准日期: '伦理委员会批准日期',
			研究疾病: '研究疾病',
			研究类型: '研究类型',
			研究设计: '研究设计',
			研究实施时间: '研究实施时间',
			数据与安全监察委员会: '数据与安全监察委员会',
        },
        // 相关试验-ClinicalTrials
        相关试验_ClinicalTrials: {
            相关试验_ClinicalTrials: '相关试验-ClinicalTrials',
            登记号: '登记号',
            试验题目: '试验题目',
            招募状态: '招募状态',
            适应症: '适应症',
            干预措施: '干预措施',
            试验分期: '试验分期',
            申办者: '申办者',
            首次提交时间: '首次提交时间',
        },
		// 相关靶点
		相关靶点: {
			相关靶点: '相关靶点',
			英文名称: '英文名称',
			中文名称: '中文名称',
			简称: '简称',
			试验数: '试验数',
		},
		// 研发管线
		研发管线: {
			研发管线: '研发管线',
			序号: '序号',
			靶点: '靶点',
			药物名称: '药物名称',
			适应症: '适应症',
			按适应症: '按适应症',
			按靶点: '按靶点',
		},
		// 相关风险信息
		风险信息: {
			风险信息: '风险信息',
		},
	},
	// ==== 试验相关 ==== //
	试验相关: {
		// 试验分期
		试验分期: {
			试验分期: '试验分期',
			Ⅰ期: 'Ⅰ期',
			Ⅰ_Ⅱ期 : 'Ⅰ/Ⅱ期',
			Ⅰ_Ⅲ期: 'Ⅰ/Ⅲ期',
			Ⅱ期: 'Ⅱ期',
			Ⅱ_Ⅲ期: 'Ⅱ/Ⅲ期',
			Ⅲ期: 'Ⅲ期',
			Ⅳ期: 'Ⅳ期',
			生物等效性试验: '生物等效性试验',
			其他: '其他',
			总数: '总数',
		},
		// 试验状态
		试验状态: {
			试验状态: '试验状态',
			已完成: '已完成',
			进行中: '进行中',
			暂停: '暂停',
			终止: '终止',
			总数: '总数',
			主动暂停: '主动暂停',
			主动终止: '主动终止',
			责令暂停: '责令暂停',
			责令终止: '责令终止',
			IEC_IRB暂停: 'IEC/IRB暂停',
			IEC_IRB终止: 'IEC/IRB终止',			
		},
    },
    // 研究者风险
    研究者风险: {
        风险详情: {
            风险列表: "风险列表",
            id: "id",
            研究者姓名: "研究者姓名",
            所在医院: "所在医院",
            来源: "来源",
            来源URL: "来源URL",
            详情: "详情",
            结果: "结果",
            发布日期: "发布日期",
        }
    },
    // 列表可视化相关
    可视化: {
        堆叠图: {
            label: '名称',
            total: '总数',
        }
    },
	// 企业信息
	企业信息: {
		公司摘要: {
			公司摘要: '公司摘要',
			logo: 'logo',
		},
		基本信息: {
			基本信息: '基本信息',
			服务内容: '服务内容',
			企业名称: '企业名称',
			企业简介: '企业简介',
			成立时间: '成立时间',
			经营状态: '经营状态',
			统一社会代码: '统一社会代码',
			法定代表人: '法定代表人',
			电话: '电话',
			邮箱: '邮箱',
			地址: '地址',
			注册资本: '注册资本',
		},
		服务信息: {
			服务信息: "服务信息",
			企业名称: "企业名称",
			公司简介: "公司简介",
			服务范围: "服务范围",
			省份: "省份",
			城市: "城市",
			重点服务领域: "重点服务领域",
			重点服务区域: "重点服务区域",
			联系人: "联系人",
			职位: "职位",
			电话: "电话",
			邮箱: "邮箱",
		},
		股票信息: {
			股票信息: "股票信息",
			股票简称: "股票简称",
			股票代码: "股票代码",
			交易市场: "交易市场",
			上市时间: "上市时间",
			上市状态: "上市状态",
		},
		生产信息: {
            生产信息: '生产信息',
			企业名称: '企业名称',
			编号: '编号',
			社会信用代码: '社会信用代码',
			分类码: '分类码',
			法定代表人: '法定代表人',
			企业负责人: '企业负责人',
			质量负责人: '质量负责人',
			省份: '省份',
			注册地址: '注册地址',
			发证日期: '发证日期',
			有效期至: '有效期至',
			发证机关: '发证机关',
			签发人: '签发人',
			日常监督机构: '日常监督机构',
			日常监督人员: '日常监督人员',
			监督举报电话: '监督举报电话',
			备注: '备注',
			生产地址和生产范围正本: '生产地址和生产范围（正本）',
			生产地址和生产范围副本: '生产地址和生产范围（副本）',
		},
		工商信息: {
            工商信息: '工商信息',
			法定代表人: '法定代表人',
			经营状态: '经营状态',
			成立日期: '成立日期',
			注册资本: '注册资本',
			实缴资本: '实缴资本',
			核准日期: '核准日期',
			统一社会信用代码: '统一社会信用代码',
			组织机构代码: '组织机构代码',
			工商注册号: '工商注册号',
			纳税人识别号: '纳税人识别号',
			进出口企业代码: '进出口企业代码',
			所属行业: '所属行业',
			企业类型: '企业类型',
			营业期限: '营业期限',
			登记机关: '登记机关',
			人员规模: '人员规模',
			参保人数: '参保人数',
			所属地区: '所属地区',
			曾用名: '曾用名',
			英文名: '英文名',
			企业地址: '企业地址',
			经营范围: '经营范围',
		},
		股东信息: {
            股东信息: '股东信息',
            发起人股东: '发起人/股东',
            股东类型: '股东类型',
            类型: '类型',
            企业证照号: '企业证照号',
            出资列表: '出资列表',
            总认缴: '总认缴',
            总实缴: '总实缴',
		},
		主要人员: {
			主要人员: '主要人员',
			姓名: '姓名',
			职务: '职务',
		},
		对外投资: {
			对外投资: '对外投资',
			被投资企业: '被投资企业',
			投资比例: '投资比例',
			认缴金额: '认缴金额',
			状态: '状态',
		},
		变更记录: {
			变更记录: '变更记录',
			变更日期: '变更日期',
			变更事项: '变更事项',
			变更前: '变更前',
			变更后: '变更后',
		},
		融资历程: {
			融资历程: '融资历程',
			日期: '日期',
			融资轮次: '融资轮次',
			金额: '金额',
			投资方: '投资方',
			新闻来源: '新闻来源',
		},
		公司公告: {
			公司公告: '公司公告',
			公告名称: '公告名称',
			受理号: '受理号',
			股票代码: '股票代码',
			关键词: '关键词',
			公告日期: '公告日期',
			公告文件: '公告文件',
		},
	},

	// 搜索条件展示
	kslgmooj: '等于',
	kslgmufk: '不等于',
	kslgmy99: '且',
	kslgn6u9: '或',
	ksmt8s0o: '包含',
	ksmt8vk9: '不包含',
	// 权限相关
	cm5vw31u: "试用用户最多显示 10 条数据。",
	// 表格相关
	共: "共",
	条: "条",
	// 切换
	按列表: '按列表',
	按可视化: '按可视化',
	按企业: '按企业',
	按集团: '按集团',
	切换列表显示维度: '切换列表显示维度',
	显隐列: '显隐列',
	显示_隐藏: '显示/隐藏',
	刷新: '刷新',
	// 可视化相关
    筛选: '筛选',
    导出数据: '导出当前结果（最多导出前500条！）',
	// 杂项
	显示全部: '显示全部',
	查看PDF: '查看PDF',
	源链接地址: '源链接地址',
	序号: '序号',
	加载更多: '加载更多',
	数据已全部加载: '数据已全部加载！',
	仅定制获取: '仅定制获取',
	时光轴: '时光轴',
	天: '天',
	点击查看: '点击查看',
	暂无数据: '暂无数据',
    加载中: '客官稍等，玩命加载中...',
    仿制药首家登记: '仿制药首家登记',
    联系客服获取: '联系客服获取',
}